/* @ngInject */
function temporaryFileService (CONSTANTS, UploadService) {
  var service = {
    uploadFile: uploadFile
  }
  return service

  function uploadFile (file, fnDone, fnOnProgress, fnError, aAllFiles, mExtraData) {
    var sUrl = CONSTANTS.URL_TEMPORARY_FILES

    file.req = UploadService.uploadWithCustomProgress(
      sUrl,
      [file],
      {
        fnSuccess: fnDone,
        fnError: fnError,
        fnProgress: () => event => {
          if (!event.lengthComputable) {
            return
          }

          var percentage = event.loaded / event.total * 100
          file.percentage = parseInt(percentage, 10)

          if (fnOnProgress) {
            fnOnProgress()
          }
        }
      },
      {
        simultaneousLimit: 5,
        allFiles: aAllFiles
      },
      mExtraData
    )

    return file
  }
}

export { temporaryFileService }
